"use client";

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const SKELETONS = [
  {
    id: 0,
    top: "14%",
    left: "10%",
    width: "32%",
    height: "16%",
    radius: "8px",
  },
  {
    id: 1,
    top: "14%",
    left: "52%",
    width: "38%",
    height: "16%",
    radius: "9999px",
  },
  {
    id: 2,
    top: "42%",
    left: "10%",
    width: "16%",
    height: "16%",
    radius: "9999px",
  },
  {
    id: 3,
    top: "42%",
    left: "34%",
    width: "56%",
    height: "16%",
    radius: "8px",
  },
  {
    id: 4,
    top: "70%",
    left: "10%",
    width: "80%",
    height: "17%",
    radius: "10px",
  },
];

export default function Preview() {
  const [focusedIndex, setFocusedIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFocusedIndex((prev) => (prev + 1) % SKELETONS.length);
    }, 1150);
    return () => clearInterval(interval);
  }, []);

  const active = SKELETONS[focusedIndex];

  return (
    <div
      aria-hidden="true"
      className="relative flex h-full w-full items-center justify-center overflow-hidden bg-transparent select-none"
    >
      {/* Subtiles Dot-Pattern */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04] dark:opacity-[0.06]"
        style={{
          backgroundImage: "radial-gradient(currentColor 1px, transparent 1px)",
          backgroundSize: "16px 16px",
        }}
      />

      {/* Dezente [Tab ⇥] Taste unten rechts, die im Takt mitwippt */}
      <motion.div
        key={`tab-${focusedIndex}`}
        initial={{ scale: 0.92, y: 1 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 400, damping: 18 }}
        className="pointer-events-none absolute bottom-3 right-3.5 rounded-md border border-emerald-500/30 bg-emerald-500/10 px-1.5 py-0.5 font-mono text-[10px] font-bold text-emerald-700 shadow-2xs dark:text-emerald-300"
      >
        Tab ⇥
      </motion.div>

      <div className="relative h-[82%] w-[88%] max-w-[210px]">
        {/* Skeletons */}
        {SKELETONS.map((skel, idx) => {
          const isFocused = idx === focusedIndex;
          return (
            <div
              key={skel.id}
              className={`absolute transition-colors duration-300 ${
                isFocused
                  ? "bg-emerald-500/20 dark:bg-emerald-500/25"
                  : "bg-zinc-200/90 dark:bg-zinc-800/90"
              }`}
              style={{
                top: skel.top,
                left: skel.left,
                width: skel.width,
                height: skel.height,
                borderRadius: skel.radius,
              }}
            />
          );
        })}

        {/* Butterweicher Framer-Motion Focus-Ring */}
        <motion.div
          className="pointer-events-none absolute z-10"
          animate={{
            top: active.top,
            left: active.left,
            width: active.width,
            height: active.height,
            borderRadius: active.radius,
          }}
          transition={{
            type: "spring",
            stiffness: 280,
            damping: 26,
            mass: 0.7,
          }}
          style={{
            outline: "2.5px solid #10b981",
            outlineOffset: "3px",
            boxShadow: "0 0 14px rgba(16, 185, 129, 0.25)",
          }}
        />
      </div>
    </div>
  );
}
